
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categorias]",
      function () {
        return require("private-next-pages/[categorias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categorias]"])
      });
    }
  